module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/banner_sola_plan-c3f1f0c51d5caa3d1e951edb679402bb.jpg";